<template>
  <div class="info-sidebar">
    <div class="info-back" @click="backToHelp">
      <div class="info-title">Back to Help Center</div>
    </div>
    <div class="info-full-page" @click="goFullPage">
      <div class="info-title">View Full Page</div>
    </div>
    <div class="tabs flex">
      <div
        class="tab"
        v-for="(tab, index) in tabs"
        @click="setTabByURL(tab.url)"
        :key="index"
        :class="currentTab == tab.url ? 'selected-tab' : ''"
      >
        {{ tab.name }}
      </div>
    </div>
    <StillNeedHelp />
  </div>
</template>

<script>
import StillNeedHelp from "./StillNeedHelp.vue";

export default {
  name: "InfoSidebar",
  components: {
    StillNeedHelp,
  },
  props: {
    tabs: Array,
    currentTab: Object,
  },
  methods: {
    setTabByURL(url) {
      this.$emit("setTabByURL", url);
    },
    backToHelp() {
      this.$emit("backToHelp");
    },
  },
};
</script>

<style scoped>
.info-sidebar {
  /* margin-top: 80px; */
  margin-top: 115px;
}
.info-sidebar .tabs {
  width: 242px;
  margin: 0 auto;
  padding: 10px 10px;
  border-radius: 12px;
  background-color: hsla(0, 0%, 97.6%, 0.79);
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(62 62 62 / 10%) 0px 3px 6px, rgb(193 193 193 / 20%) 0px 9px 24px;
  box-sizing: border-box;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
}
.info-sidebar .tab {
  font-weight: 600;
  font-size: 18px;
  padding: 8px 14px;
  line-height: 20px;
  height: 42px;
  margin-right: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid transparent;
  margin-top: 3px;
  margin-bottom: 3px;
}
.info-sidebar .tab:hover {
  font-weight: 600;
  font-size: 18px;
  padding: 8px 14px;
  line-height: 20px;
  height: 42px;
  margin-right: 8px;
  background-color: #fff;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(169 169 169 / 10%) 0px 3px 6px, rgb(239 239 239 / 20%) 0px 9px 24px;
  border-radius: 360px;
  align-items: center;
}
.info-sidebar .selected-tab {
  font-weight: 600;
  font-size: 18px;
  padding: 8px 14px;
  line-height: 20px;
  height: 42px;
  margin-right: 8px;
  background-color: #fff;
  border-color: hsla(0, 0%, 80.8%, 0.5);
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 86% / 52%);
  color: #2c2c2c;
  border-radius: 360px;
  border: 1px solid transparent;
  align-items: center;
}
.info-back,
.info-full-page {
  width: 242px;
  margin: 0 auto;
  padding: 0px 0px;
  border-radius: 360px;
  background-color: #ffffff;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(62 62 62 / 10%) 0px 3px 6px, rgb(193 193 193 / 20%) 0px 9px 24px;
  box-sizing: border-box;
  /* margin-bottom: 80px; */
  /* margin-bottom: 60px; */
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.info-back:hover,
.info-full-page:hover {
  background-color: #efefef;
}
.info-full-page {
  margin-bottom: 60px;
}
.info-back {
  margin-bottom: 10px;
}
.info-title {
  font-weight: 700;
  padding: 8px 14px;
  height: 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  justify-content: center;
}
</style>